import { getOriginFrom } from 'ym-reporter-vue';
import {
  getUID, appendQuery,
} from '@/utils/index';
import event from '@/utils/bus';
import { getWechatConfig } from '@/services/app';
import wxJsSdk from '@/utils/share/wx-js-sdk';

export default {
  config() {
    return new Promise(async (resolve, reject) => {
      const url = window.location.href.split('#')[0];
      try {
        const data = await getWechatConfig(url);
        wxJsSdk.changeConfigParams(data);
        wxJsSdk.configWeChat();
        return resolve();
      } catch (e) {
        return reject();
      }
    });
  },
  setDefaultParams(params) {
    return wxJsSdk.setDefaultParams(params);
  },
  changeShareParams(params) {
    // 添加origin标记
    const origin = getOriginFrom();
    // 添加ymsf标记
    Object.keys(params).forEach((key) => {
      const { link } = params[key];
      if (link) {
        const queryOptions = {};
        const uid = getUID();
        if (uid !== 0) {
          queryOptions.ymsf = getUID();
        }
        if (origin !== '') {
          queryOptions.origin = origin;
        }
        params[key].link = appendQuery(link, queryOptions);
      }
      return params[key];
    });
    wxJsSdk.changeParams(params);
  },
  once(name, cb) {
    return event.$once(name, cb);
  },
  on(name, cb) {
    return event.$on(name, cb);
  },
  off(name, cb) {
    return event.$off(name, cb);
  },
  getWechatMenuShareAppParams() {
    return wxJsSdk.getWechatMenuShareAppParams();
  },
  getWechatMenuShareAppLink() {
    return wxJsSdk.getWechatMenuShareAppLink();
  },
  getWebQZoneShareUrl() {
    return wxJsSdk.getWebQZoneShareUrl();
  },
  getWebWeiboShareUrl() {
    return wxJsSdk.getWebWeiboShareUrl();
  },
  pay(params) {
    wxJsSdk.changePayParams(params);
    return wxJsSdk.wxPay();
  },
  startRecord() {
    return wxJsSdk.startRecord();
  },
  stopRecord() {
    return wxJsSdk.stopRecord();
  },
  onVoiceRecordEnd() {
    return wxJsSdk.onVoiceRecordEnd();
  },
  playVoice(localId) {
    return wxJsSdk.playVoice(localId);
  },
  pauseVoice(localId) {
    return wxJsSdk.pauseVoice(localId);
  },
  stopVoice(localId) {
    return wxJsSdk.stopVoice(localId);
  },
  onVoicePlayEnd() {
    return wxJsSdk.onVoicePlayEnd();
  },
  uploadVoice(localId, isShowProgressTips = 1) {
    return wxJsSdk.uploadVoice(localId, isShowProgressTips);
  },
};
